import { connect } from 'react-redux';
import NewPasswordPage from 'pages/NewPasswordPageNew';
import Actions from 'store/auth/actions';
import ErrorActions from 'store/error/actions';

const mapStateToProps = state => {
  return {
    isRequesting: state.auth.isRequesting,
  };
};

const mapDispatchToProps = {
  resetPassword: Actions.Creators.resetPasswordRequest,
  setError: ErrorActions.Creators.setError,
};

export default connect(mapStateToProps, mapDispatchToProps)(NewPasswordPage);
